import { Button } from "@/components/ui/button";
import AuthPageShell from "./AuthPageShell";

type Props = {
  onSignIn: () => Promise<void>;
  busy: boolean;
  error: string | null;
};

export default function SignInFormMsal({ onSignIn, busy, error }: Props) {
  return (
    <AuthPageShell>
      <div className="space-y-2">
        <h2 className="text-2xl font-bold tracking-tight">Sign in</h2>
        <p className="text-muted-foreground">
          Use your Team PBS Microsoft account to access PBS Connect.
        </p>
      </div>

      <Button
        type="button"
        size="lg"
        className="w-full gap-2 [&_svg]:size-5"
        onClick={onSignIn}
        disabled={busy}
      >
        <svg viewBox="0 0 21 21" fill="none" aria-hidden="true">
          <rect x="1" y="1" width="9" height="9" fill="#F25022" />
          <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
          <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
          <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
        </svg>
        {busy ? "Redirecting..." : "Sign in with Microsoft"}
      </Button>

      {error && (
        <p role="alert" className="text-center text-sm text-destructive">
          {error}
        </p>
      )}

      <p className="text-center text-xs text-muted-foreground">
        Access is restricted to authorized Team PBS members.
      </p>
    </AuthPageShell>
  );
}
